import Vue from 'vue';
import EncorePlugin from '@/helpers/EncorePlugin'
import { VueHammer } from 'vue2-hammer'
import SvgPlugin from '@/../svg'
import * as Sentry from '@sentry/browser'
import { config, setConfigValue } from '@num/config'
import FilterFwg from '@/helpers/FilterFwg'
import DirectiveHtmlClass from '@/helpers/DirectiveHtmlClass'
import DirectiveClickOutside from '@/helpers/DirectiveClickOutside'

import store from '@num/store/ordernumber'
/**
 * Create a fresh Vue Application instance
 */
export default function basepage(page, opts = {}) {

  if (opts.theme) {
    setConfigValue("THEME", opts.theme)
  }

  //TODO: we have to outsource sentry config
  if (config.SENTRY) {
    Sentry.init({ dsn: config.SENTRY_DSN, environment: config.SENTRY_ENV });
    Sentry.getCurrentScope().setTag("app", "numbersystem");
    Sentry.getCurrentScope().setExtra("store", config.store);
    Sentry.getCurrentScope().setExtra("filter", config.filter);
    Sentry.getCurrentScope().setExtra("githash", config.SENTRY_GITHASH);
  }

  //plugins
  Vue.use(EncorePlugin)
  Vue.use(VueHammer)
  Vue.use(SvgPlugin)
  Vue.use(FilterFwg)
  Vue.use(DirectiveHtmlClass)
  Vue.use(DirectiveClickOutside)

  Vue.mixin({
    methods: {
      isTheme(value) {
        if (config.THEMES.indexOf(value) < 0) {
          throw new Error("Theme not found: " + value)
        }
        return config.THEME == value
      },
      hasFeature(value) {
        if (value && value.indexOf('FEATURE_') == 0 && config[value] !== undefined) {
          return config[value]
        } else {
          throw new Error("Feature not valid: " + value)
        }
      },
      themeValue(value) {
        if (value && value.indexOf('THEME_') == 0 && config[value] !== undefined) {
          return config[value]
        } else {
          throw new Error("Theme value not valid: " + value)
        }
      },
      langValue(value) {
        if (value && value.indexOf('LANG_') == 0 && config[value] != undefined) {
          return config[value]
        } else {
          throw new Error("Lang value not valid: " + value)
        }
      },
    }
  })

  new Vue({
    el: '#app',
    data: store.state,
    render(h) {
      return h(page, {})
    }
  });
}
